<script lang="ts">
  let visible = false;
  
  function toggle() {
    visible = !visible;
  }
  
  // Using standard Svelte reactivity instead of runes
  $: if (visible) {
    // Reactive statement for any future side effects when visibility changes
  }

  // Keyboard event handler for accessibility
  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggle();
    }
  }
</script>

<button 
  class="menu-container"
  onclick={toggle}
  onkeydown={handleKeyDown}
  aria-expanded={visible}
  aria-label="メニュー"
>
  <div class={visible ? 'hamburger active' : 'hamburger'}>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <nav class={visible ? 'globalMenuSp visible' : 'globalMenuSp'}>
    <ul>
      <li>
        <a href="#service">サービスについて</a>
      </li>
      <li>
        <a href="#about">スパトレについて</a>
      </li>
      <li>
        <a href="#career">採用情報</a>
      </li>
      <li>
        <a href="#info">お知らせ</a>
      </li>
      <li>
        <a href="mailto:info@sptr.jp">お問い合わせ</a>
      </li>
    </ul>
  </nav>
</button>

<style>
  /* Use Svelte's built-in CSS scoping */
  :global(.menu-container) {
    all: unset;
    cursor: pointer;
  }

  :global(.hamburger) {
    display: block;
    position: relative;
    z-index: 10;
    right: 0px;
    top: 2px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    text-align: center;
  }

  .hamburger span {
    display: block;
    position: absolute;
    width: 18px;
    height: 2px;
    left: 6px;
    background: #7521da;
    transition: 0.5s all;
  }

  .hamburger span:nth-child(1) {
    top: 7px;
  }

  .hamburger span:nth-child(2) {
    top: 14px;
  }

  .hamburger span:nth-child(3) {
    top: 21px;
  }

  /* ナビ開いてる時のボタン */
  .hamburger.active span:nth-child(1) {
    top: 16px;
    left: 6px;
    width: 26px;
    background: #fff;
    transform: rotate(-45deg);
  }

  .hamburger.active span:nth-child(2) {
    left: 60%;
    opacity: 0;
    animation: active-hamburger-bar02 0.8s forwards;
  }

  @keyframes active-hamburger-bar02 {
    100% {
      height: 0;
    }
  }

  .hamburger.active span:nth-child(3) {
    top: 16px;
    width: 26px;
    background: #fff;
    transform: rotate(45deg);
  }

  .hamburger::after {
    position: absolute;
    top: 80%;
    right: -30%;
    display: block;
    content: '';
    width: 42px;
    height: 42px;
    margin: -32px 0 0 -32px;
    border-radius: 50%;
    border: 2px solid rgba(0, 0, 0, 0);
    transition: all 0.75s;
  }

  .hamburger.active::after {
    border: 2px solid #fff;
  }

  :global(nav.globalMenuSp) {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    color: #fff;
    background: #7521da;
    text-align: center;
    width: 100%;
    height: 100vh;
    display: none;
    transition: opacity 0.6s ease, visibility 0.6s ease;
  }

  nav.globalMenuSp ul {
    margin: 100px auto;
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  nav.globalMenuSp ul li {
    list-style-type: none;
    padding: 0;
    width: 100%;
    transition: 0.4s all;
  }

  nav.globalMenuSp ul li:last-child {
    padding-bottom: 0;
  }

  nav.globalMenuSp ul li:hover {
    opacity: 0.5;
  }

  nav.globalMenuSp ul li a {
    display: block;
    color: #fff;
    padding: 10px 0;
    text-decoration: none;
    font-size: 1.4rem;
  }

  nav.globalMenuSp.visible {
    display: block;
  }
</style>
